// Tabellenansicht mit Spaltenauswahl, PDF-Export, Neueintrag & Filter "Anzahl > 0"
import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";

const SPALTEN = [
  "anzahl", "name", "klassierung", "region", "nation", "jahrgang", "preis", "kaufdatum", "trinkreife",
  "scherrer_qualitaet", "preisrahmen_93", "urteil_ubb", "trinkdatum", "beschreibung", "wert",
  "bemerkung", "kaufort", "reif", "regal", "gabriel", "total"
];

export default function WeinkellerApp() {
  const [weine, setWeine] = useState([]);
  const [filter, setFilter] = useState("");
  const [sichtbareSpalten, setSichtbareSpalten] = useState(() => Object.fromEntries(SPALTEN.map(s => [s, true])));
  const [nurVerfuegbar, setNurVerfuegbar] = useState(false);
  const [neuerWein, setNeuerWein] = useState(Object.fromEntries(SPALTEN.map(s => [s, ""])));

  useEffect(() => {
    fetch("/api/weine.php")
      .then(res => res.json())
      .then(data => setWeine(data));
  }, []);

  const toggleSpalte = (key) => {
    setSichtbareSpalten({ ...sichtbareSpalten, [key]: !sichtbareSpalten[key] });
  };

  const gefiltert = weine.filter(w => {
    return (
      (!filter || w.name?.toLowerCase().includes(filter.toLowerCase()) || w.region?.toLowerCase().includes(filter.toLowerCase())) &&
      (!nurVerfuegbar || parseInt(w.anzahl) > 0)
    );
  });

  const weinHinzufuegen = async () => {
    await fetch("/api/add_wein.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(neuerWein)
    });
    const aktualisiert = await fetch("/api/weine.php").then(res => res.json());
    setWeine(aktualisiert);
    setNeuerWein(Object.fromEntries(SPALTEN.map(s => [s, ""])));
  };

const exportierePDF = () => {
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "A4" });
  const sichtbare = SPALTEN.filter(s => sichtbareSpalten[s]);
  const head = [sichtbare.map(s => s.toUpperCase().replace(/_/g, " "))];
  const body = gefiltert.map(w => sichtbare.map(s => w[s] || ""));

  doc.setFontSize(10);
  doc.text("Weinliste", 40, 40);
  doc.autoTable({
    head,
    body,
    startY: 60,
    styles: { fontSize: 8, cellPadding: 3 },
    headStyles: { fillColor: [41, 128, 185], textColor: 255 },
    margin: { left: 40, right: 40 },
    theme: "striped",
  });
  doc.save("weinliste.pdf");
};

  return (
    <div style={{ padding: '1rem' }}>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>🍷 Weinliste</h1>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1rem' }}>
        <input type="text" placeholder="Suche nach Name, Region..." value={filter} onChange={e => setFilter(e.target.value)} style={{ width: '15rem' }} />
        <label style={{ fontSize: '0.875rem' }}>
          <input type="checkbox" checked={nurVerfuegbar} onChange={() => setNurVerfuegbar(!nurVerfuegbar)} style={{ marginRight: '0.5rem' }} />
          Nur verfügbare Weine anzeigen (Anzahl > 0)
        </label>
        <button onClick={exportierePDF} style={{ padding: '0.4rem 1rem' }}>PDF exportieren</button>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', marginBottom: '1rem' }}>
        {SPALTEN.map(spalte => (
          <label key={spalte} style={{ display: 'flex', alignItems: 'center', fontSize: '0.875rem' }}>
            <input type="checkbox" checked={sichtbareSpalten[spalte]} onChange={() => toggleSpalte(spalte)} style={{ marginRight: '0.25rem' }} />
            {spalte}
          </label>
        ))}
      </div>

      <div style={{ overflowX: 'auto', marginBottom: '2rem' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
          <thead>
            <tr>
              {SPALTEN.filter(sp => sichtbareSpalten[sp]).map(spalte => (
                <th key={spalte} style={{ border: '1px solid #ccc', padding: '0.5rem', backgroundColor: '#f0f0f0', textAlign: 'left' }}>{spalte}</th>
              ))}
              <th style={{ border: '1px solid #ccc', padding: '0.5rem' }}></th>
            </tr>
          </thead>
          <tbody>
            {gefiltert.map((wein, idx) => (
              <tr key={idx} style={{ borderTop: '1px solid #ccc' }}>
                {SPALTEN.filter(sp => sichtbareSpalten[sp]).map(spalte => (
                  <td key={spalte} style={{ border: '1px solid #ccc', padding: '0.5rem' }}>{wein[spalte]}</td>
                ))}
                <td style={{ border: '1px solid #ccc', padding: '0.5rem' }}>
                  <button onClick={async () => {
                    await fetch(`/api/delete_wein.php?id=${wein.id}`);
                    setWeine(w => w.filter(x => x.id !== wein.id));
                  }} style={{ padding: '0.25rem 0.5rem', backgroundColor: '#dc2626', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Löschen</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>➕ Neuer Wein</h2>
      <div style={{ display: 'grid', gap: '0.5rem', maxWidth: '40rem' }}>
        {SPALTEN.map(key => (
          <input key={key} name={key} placeholder={key} value={neuerWein[key]} onChange={e => setNeuerWein({ ...neuerWein, [key]: e.target.value })} style={{ padding: '0.5rem' }} />
        ))}
        <button onClick={weinHinzufuegen} style={{ padding: '0.6rem', backgroundColor: '#2563eb', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Hinzufügen</button>
      </div>
    </div>
  );
}
